import styled from 'styled-components';

export const Container = styled.div`
  .banner-carousel {
    position: relative;
    width: 100%;
    max-width: 600px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .banner-content {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .dots {
    position: absolute;
    width: 96%;
    bottom: 2px;
    display: flex;
    gap: 5px;
    justify-content: center;
  }

  .dot {
    width: 10px;
    height: 10px;
    background: ${(props) => props.theme.$gray400};
    border-radius: 50%;
    opacity: 0.5;
    cursor: pointer;
  }

  .dot.active {
    opacity: 1;
  }
`;
